var _defs, _metadata, _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _circle, _g3, _circle2, _circle3, _circle4, _g4, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1400 1133",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:31.9593}\r\n    .str1 {stroke:black;stroke-width:31.9593;stroke-linecap:round}\r\n    .str2 {stroke:black;stroke-width:31.9593;stroke-linecap:round}\r\n    .fil0 {fill:none}\r\n    .fil2 {fill:black}\r\n    .fil4 {fill:#FF6633}\r\n    .fil1 {fill:#FF9933}\r\n    .fil6 {fill:white}\r\n    .fil5 {fill:white;fill-rule:nonzero}\r\n    .fil3 {fill:white;fill-opacity:0.501961}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688 211c-45,0 -305,9 -455,331 -181,390 157,438 455,438 296,0 635,-47 454,-438 -150,-322 -410,-331 -454,-331z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_211453816"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1400,
    height: 1133
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M267 528c0,0 -59,-133 -77,-233 -14,-77 11,-124 19,-135 8,-13 72,-6 134,27 61,32 120,91 138,109l-214 232z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1112 528c0,0 59,-133 77,-233 13,-77 -11,-124 -19,-135 -9,-13 -72,-6 -134,27 -61,32 -120,91 -138,109l214 232z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M314 447l101 -115c0,0 -99,-79 -135,-74 -36,6 9,129 34,189z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1065 447l-101 -115c0,0 99,-79 135,-74 36,6 -9,129 -34,189z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M688 211c-45,0 -305,9 -455,331 -181,390 157,438 455,438 296,0 635,-47 454,-438 -150,-322 -410,-331 -454,-331z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M692 1203c200,0 363,-98 363,-218 0,-121 -163,-219 -363,-219 -200,0 -362,98 -362,219 0,120 162,218 362,218z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "695,473 738,268 781,63 695,63 608,63 652,268 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "610,458 550,260 490,63 447,82 404,100 507,279 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "780,458 840,260 899,63 942,82 985,100 882,279 "
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M688 211c-45,0 -305,9 -455,331 -181,390 157,438 455,438 296,0 635,-47 454,-438 -150,-322 -410,-331 -454,-331z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M604 658l-63 0 0 0 0 -3 -1 -3 0 -3 0 -3 -1 -2 -1 -3 0 -3 -1 -2 -1 -3 -1 -2 -2 -2 -1 -2 -1 -2 -2 -3 -1 -1 -2 -2 -2 -2 -1 -2 -2 -1 -2 -2 -2 -1 -2 -1 -2 -1 -1 -1 -2 -1 -3 -1 -2 0 -2 -1 -2 0 -2 -1 -2 0 -2 0 0 -64 5 0 6 1 6 1 5 1 6 1 5 2 5 2 5 2 5 2 5 3 5 3 4 3 4 3 4 4 4 4 4 4 4 4 3 4 3 4 3 5 3 5 3 5 2 5 2 5 2 5 2 5 1 6 1 6 1 5 1 6 0 6 0 6 0 0zm-109 117l0 -64 0 0 2 0 2 0 2 0 2 -1 2 0 2 -1 3 -1 2 -1 1 -1 2 -1 2 -1 2 -1 2 -2 2 -1 1 -2 2 -1 2 -2 1 -2 2 -2 1 -2 1 -3 2 -2 1 -2 1 -3 1 -2 0 -3 1 -2 1 -3 0 -3 0 -3 1 -2 0 -3 63 0 0 6 0 5 -1 6 -1 6 -1 5 -1 6 -2 5 -2 5 -2 6 -2 5 -3 4 -3 5 -3 5 -3 4 -3 5 -4 4 -4 4 -4 3 -4 4 -4 3 -4 3 -5 3 -5 3 -5 2 -5 3 -5 2 -5 1 -6 2 -5 1 -6 0 -6 1 -5 0 0 0zm-110 -117l64 0 0 0 0 3 0 2 0 3 1 3 0 3 1 2 1 3 0 2 1 3 2 2 1 2 1 3 1 2 2 2 1 2 2 2 2 1 1 2 2 1 2 2 2 1 2 1 2 1 2 1 2 1 2 1 2 1 2 0 2 1 2 0 2 0 3 0 0 64 -6 0 -6 -1 -6 0 -5 -1 -6 -2 -5 -1 -5 -2 -5 -3 -5 -2 -5 -3 -4 -3 -5 -3 -4 -3 -4 -4 -4 -3 -4 -4 -4 -4 -3 -5 -3 -4 -3 -5 -3 -5 -2 -4 -3 -5 -2 -6 -2 -5 -1 -5 -2 -6 -1 -5 -1 -6 -1 -6 0 -5 0 -6 0 0zm110 -118l0 64 0 0 -3 0 -2 0 -2 1 -2 0 -2 1 -2 0 -2 1 -2 1 -2 1 -2 1 -2 1 -2 1 -2 2 -2 1 -1 2 -2 2 -2 2 -1 1 -2 3 -1 2 -1 2 -1 2 -2 2 -1 3 0 2 -1 3 -1 3 0 2 -1 3 0 3 0 3 0 3 -64 0 0 -6 0 -6 1 -6 1 -5 1 -6 2 -6 1 -5 2 -5 2 -5 3 -5 2 -5 3 -5 3 -5 3 -4 3 -4 4 -4 4 -4 4 -4 4 -4 4 -3 5 -3 4 -3 5 -3 5 -2 5 -2 5 -2 5 -2 6 -1 5 -1 6 -1 6 -1 6 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil6",
    d: "M495 572c43,0 77,38 77,86 0,47 -34,85 -77,85 -43,0 -78,-38 -78,-85 0,-48 35,-86 78,-86z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 516,
    cy: 659,
    r: 71
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M771 658l0 0 0 -6 0 -6 1 -6 1 -5 1 -6 2 -6 1 -5 2 -5 2 -5 3 -5 2 -5 3 -5 3 -5 3 -4 4 -4 3 -4 4 -4 4 -4 4 -4 4 -3 5 -3 4 -3 5 -3 5 -2 5 -2 5 -2 6 -2 5 -1 6 -1 5 -1 6 -1 6 0 0 64 -3 0 -2 0 -2 1 -2 0 -2 1 -2 0 -2 1 -2 1 -2 1 -2 1 -2 1 -2 1 -2 2 -2 1 -1 2 -2 2 -1 2 -2 1 -1 3 -2 2 -1 2 -1 2 -1 2 -1 3 -1 2 -1 3 -1 3 0 2 -1 3 0 3 0 3 0 3 0 0 -64 0zm110 117l0 0 -6 0 -6 -1 -5 0 -6 -1 -5 -2 -6 -1 -5 -2 -5 -3 -5 -2 -5 -3 -4 -3 -5 -3 -4 -3 -4 -4 -4 -3 -4 -4 -3 -4 -4 -5 -3 -4 -3 -5 -3 -5 -2 -4 -3 -5 -2 -6 -2 -5 -1 -5 -2 -6 -1 -5 -1 -6 -1 -6 0 -5 0 -6 64 0 0 3 0 2 0 3 1 3 0 3 1 2 1 3 1 2 1 3 1 2 1 2 1 3 2 2 1 2 2 2 1 2 2 1 1 2 2 1 2 2 2 1 2 1 2 1 2 1 2 1 2 1 2 1 2 0 2 1 2 0 2 0 3 0 0 0 0 64zm109 -117l0 0 0 6 0 5 -1 6 -1 6 -1 5 -1 6 -2 5 -2 5 -2 6 -2 5 -3 4 -3 5 -3 5 -3 4 -3 5 -4 4 -4 4 -3 3 -5 4 -4 3 -4 3 -5 3 -5 3 -5 2 -5 3 -5 2 -5 1 -6 2 -5 1 -6 0 -6 1 -5 0 0 -64 2 0 2 0 2 0 2 -1 3 0 2 -1 2 -1 2 -1 2 -1 2 -1 1 -1 2 -1 2 -2 2 -1 2 -2 1 -1 2 -2 1 -2 2 -2 1 -2 1 -3 2 -2 1 -2 1 -3 1 -2 0 -3 1 -2 1 -3 0 -3 0 -3 1 -2 0 -3 0 0 63 0zm-109 -118l0 0 5 0 6 1 6 1 5 1 6 1 5 2 5 2 5 2 5 2 5 3 5 3 4 3 4 3 5 4 3 4 4 4 4 4 3 4 3 4 3 5 3 5 3 5 2 5 2 5 2 5 2 5 1 6 1 6 1 5 1 6 0 6 0 6 -63 0 0 -3 -1 -3 0 -3 0 -3 -1 -2 -1 -3 0 -3 -1 -2 -1 -3 -1 -2 -2 -2 -1 -2 -1 -2 -2 -3 -1 -1 -2 -2 -1 -2 -2 -2 -2 -1 -2 -2 -2 -1 -1 -1 -2 -1 -2 -1 -2 -1 -2 -1 -2 0 -3 -1 -2 0 -2 -1 -2 0 -2 0 0 0 0 -64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil6",
    d: "M881 572c-43,0 -78,38 -78,86 0,47 35,85 78,85 43,0 78,-38 78,-85 0,-48 -35,-86 -78,-86z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 859,
    cy: 659,
    r: 71
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 838,
    cy: 658,
    r: 28
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 537,
    cy: 658,
    r: 28
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_211456312"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M276 785c0,0 -101,17 -228,98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M339 825c0,0 -126,46 -272,180"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M396 859c0,0 -76,58 -147,182"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M1099 785c0,0 101,17 228,98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M1036 825c0,0 127,46 272,180"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M979 859c0,0 76,58 147,182"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M691 814c0,23 2,47 0,69 -2,35 -76,40 -81,-22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M692 814c0,23 -2,47 0,69 3,35 77,40 81,-22"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M692 861c21,0 79,-58 69,-67 -10,-10 -127,-10 -138,0 -10,9 49,67 69,67z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni11);
export default __webpack_public_path__ + "static/media/ani11.4ffa898ba33a204f50374b37695532f0.svg";
export { ForwardRef as ReactComponent };